export default __webpack_public_path__ + "static/media/HelveticaNeue.8b0e1de6.ttf";